<template>
  <div class="dialog-container wt-dialog-container ">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" >
      <wt-form-table-list ref="goodsTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="countReal" slot-scope="data">
          <span>{{ $wtUtil.transWeight(data.row.countReal) }}</span>
        </template>
        <template slot="photo" slot-scope="data">
          <wt-auth slot="error" class="search-form-btn">
            <el-button size="mini" type="primary" @click="toViewImg(data.row)">查看</el-button>
          </wt-auth>
        </template>
        <template slot="deliveryWay" slot-scope="data">
          <span>{{data.row.deliveryWay | FILTER_Delivery_State}}</span>
        </template>
       </wt-form-table-list>
    </wt-form-table>
    <image-viewer :z-index="999" :initial-index="0" v-if="showViewer" :on-close="closeViewer" :url-list="previewSrcList"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ImageViewer from '@/components/image-viewer/index.vue'
export default {
  name: 'SiteOutboundViewTab',
  isAutoComponent: true,
  components: { ImageViewer },
  props: {
    hideBtn: Boolean,
    siteId: Number
  },
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      detailFormButtons: {
        title: '投递记录',
        elements: [{ name: '取消', key: 'CLOSE', action: 'CLOSE' }]
      },
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULES_GOODS',
        formComponent: {
          list: { type: 'default', value: '/modules/site/siteApproveGarbageList', params: { siteId: '' }}
        },
        formInputsData: [{ name: '出库时间', key: 'dataTimeRange', value: [], type: 'datetime' }],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/site/siteApproveGarbageListImport',
          fileName: '出库记录' }],
        formTableData: [
          { name: '物品名称', key: 'name', type: 'text' },
          { name: '出库重量（kg/个）', key: 'countReal', type: 'custom' },
          { name: '出库时间', key: 'operatorTime', type: 'text', sortable: 'custom' },
          { name: '申请人', key: 'employeesName', type: 'text' },
          { name: '货物图片', key: 'photo', type: 'custom' },
          { name: '出库人', key: 'operatorName', type: 'text' }],
        formTableButtonsData: [],
        formResult: { },
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonHidden: true }
      },
      showViewer: false,
      previewSrcList: []
    }
  },
  created() {
    this.form.formComponent.list.params.siteId = this.siteId
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    toViewImg(row) {
      if (row.photo && row.photo.length > 0) {
        this.previewSrcList = []
        if (row.photo && row.photo.length > 0) {
          const splitResult = row.photo.split(',')
          for (const item of splitResult) {
            this.previewSrcList.push(this.imgUrl + item)
          }
          this.showViewer = true
        }
      } else {
        this.$message({ message: '未上传图片', type: 'warning' })
      }
    },
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      }
    },
    onButtonAction(data) {},
    closeViewer() {
      this.showViewer = false
    }
  }
}
</script>
